import TerceroService from 'src/modules/tercero/terceroService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TERCERO_VIEW';

const terceroViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: terceroViewActions.FIND_STARTED,
      });

      const record = await TerceroService.find(id);

      dispatch({
        type: terceroViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: terceroViewActions.FIND_ERROR,
      });

      getHistory().push('/tercero');
    }
  },
};

export default terceroViewActions;
